var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-container"},[(_vm.validationCode)?_c('Texting',{attrs:{"format":"h2","bold":""}},[_vm._v(" "+_vm._s(_vm.validationCode)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }